import React from "react";

import { Card, Col, Row } from "react-bootstrap";
import Button from "components/Button";
import Errors from "./Errors";

import "./UploadFailed.scss";

interface UploadFailedError {
  type?: string;
  format?: string;
  // Preserves the original PropTypes key spelling ("resaon") — see UploadFailed.js.
  resaon?: string;
}

// Mirrors the FailedJob shape consumed by ./Errors. PropTypes declared failedJob
// as arrayOf(object), but it is passed straight through to <Errors>, which reads
// it as a single object. Typed to match the real value flowing through.
interface FailedJob {
  id?: string | number;
  filename?: string;
  status?: string;
  group?: { name?: string };
  errors?: UploadFailedError[];
}

interface Props {
  failedJob?: FailedJob;
  isIconAdmin?: boolean;
  onClose?: () => void;
  showForm?: () => void;
  errors?: UploadFailedError[];
}

interface State {
  showForm: boolean;
}

export class UploadFailed extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showForm: false,
    };
  }

  _renderFailedJobs = () => {
    return (
      <div className="download-employee-template">
        <div className="main-content">
          <Row>
            <Col>
              <Card>
                <Card.Title>
                  <p className="page-header">Errors processing file... </p>
                  <p className="page-subtext">
                    Some records failed to import to the system, please check
                    them, and upload a revised file.
                  </p>
                </Card.Title>
                <Card.Body>
                  {/* Errors requires failedJob; pass through unchanged. The
                      original JS passed it unconditionally (optional here), so
                      assert to preserve identical runtime behavior. */}
                  <Errors failedJob={this.props.failedJob!} />
                </Card.Body>
                <div className="submit btn-row">
                  {this.props.isIconAdmin && (
                    <Button
                      btnLabel="Go Back"
                      name="cancel"
                      color="cancel"
                      onClick={this.props.onClose}
                    />
                  )}
                  <Button
                    btnLabel="Upload File"
                    name="action"
                    onClick={this.props.showForm}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="add-employee-form" style={{ marginBottom: 8 }}>
        {this._renderFailedJobs()}
      </div>
    );
  }
}

export default UploadFailed;
